<template>
  <global-dialog-card
    :max-width="500"
    v-model="model"
    :title="`${$t('edit')} ${$t('meal_size1')}`"
  >
    <v-form v-model="valid" ref="form">
      <v-row>
        <v-col cols="12">
          <text-field
            v-model="editSizes.name"
            :label="$t('title')"
            :rules="[rules.required]"
          ></text-field>
        </v-col>
        <v-col cols="12">
          <text-field
            v-model="editSizes.poredak"
            :label="$t('align')"
            hide-details
          ></text-field>
        </v-col>
      </v-row>
    </v-form>
    <template #actions>
      <v-btn text @click="model = false">
        {{ $t("cancel") }}
      </v-btn>
      <primary-button 
        @click="editItemConfirm" 
        :disabled="!valid" 
        :dark="valid"
        :loading="loading"
      >
        {{ $t("save") }}
      </primary-button>
    </template>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import foodService from "@/services/food";

export default {
  name: "FoodPortionEditDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    editSizes: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    editItemConfirm() {
      this.loading = true;
      foodService
        .editSize(this.editSizes)
        .then(() => {
          this.showSuccessSnackbar(this.$t("saved_successfully"));
          this.model = false;
        })
        .catch((error) => {
          console.error("Error editing size:", error);
          this.showErrorSnackbar(this.$t('error_editing_size'));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
